import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getComboBoxTestIds = createTestIds('combo-box', ['control', ...elements] as const);
